import { API_ROUTES } from '@/api/apiRoutes';
import { safeAxios } from '@/services/safeAxios';
import type { ToolConfigWithInputs } from '@/types/tool-config.types';

/**
 * Writes the whole config onto the workflow's draft version. The version is resolved server-side,
 * so there is nothing to send but the payload, and a published version is refused with a 409.
 */
export const updateToolConfig = async (recipeId: string, config: ToolConfigWithInputs): Promise<void> => {
  await safeAxios.patch<void>(API_ROUTES.recipes.toolConfig({ recipeId }), config);
};

/**
 * Asks core to record which nodes are locked, the moment a lock stops deciding a tool input's
 * exposure. Idempotent: core keeps a snapshot already taken and returns it. Null while the latest
 * version is published, since core only writes to a draft.
 */
export const takeToolLockSnapshot = async (recipeId: string): Promise<{ lockedAtConversion: string[] | null }> => {
  const res = await safeAxios.post<{ lockedAtConversion: string[] | null }>(
    API_ROUTES.recipes.toolConfigLockSnapshot({ recipeId }),
  );
  return res.data;
};

/** Takes nodes out of the lock snapshot because they were unlocked. A no-op for nodes not in it. */
export const releaseToolLockSnapshot = async (recipeId: string, nodeIds: string[]): Promise<void> => {
  await safeAxios.post<void>(API_ROUTES.recipes.toolConfigLockSnapshotRelease({ recipeId }), { nodeIds });
};
